module.exports = __webpack_public_path__ + "media/images/icons/outlined/drag-6302624e59744c917927a41a61f793b7.svg";